var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow-none mt-2"},[_c('div',{staticClass:"card-body"},[_c(_vm.tfgFormula,_vm._b({tag:"Component"},'Component',_vm.params,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }